module.exports = __webpack_public_path__ + "img/6-2.de2bfb12.png";